export type ApiFileAttachment = {
  key: string;
  file: File;
};

export function toQueryString(params: object | void): string | undefined {
  if (!params) {
    return undefined;
  }

  const query = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") {
      continue;
    }

    query.set(key, String(value));
  }

  const queryString = query.toString();
  return queryString.length > 0 ? queryString : undefined;
}

export function withQueryString(path: string, params: object | void): string {
  const queryString = toQueryString(params);
  return queryString ? `${path}?${queryString}` : path;
}

export function toFormDataJsonString(value: unknown): string {
  return typeof value === "string" ? value : JSON.stringify(value);
}

export function appendFormDataAttachments(
  formData: FormData,
  attachments: ApiFileAttachment[] | void,
) {
  for (const attachment of attachments ?? []) {
    formData.append(attachment.key, attachment.file);
  }
}
